import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { Container, Grid } from '@material-ui/core';
import BoxWrapper from 'components/atoms/BoxWrapper';
import * as Yup from 'yup';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import Button from 'components/atoms/Button/Button';
import FormControlInput from 'components/molecules/FormControlInput';
import WrapperFormControl from 'components/atoms/WrapperFormControl';
import { isDisabled } from 'utils/buttonFormIsDisabled';
import { checkIfUserEmailOrPhoneNumberExists as checkIfUserEmailOrPhoneNumberExistsAction } from 'actions/authentication/index';
import LoadingScreen from 'components/molecules/LoadingScreen';
import CustomTypography from 'components/atoms/CustomTypography';
import { colors } from 'theme/Variables';

const stepOneValidationSchema = Yup.object().shape({
    name: Yup.string().required('Enter your name!'),
    email: Yup.string().email('Invalid email!').required('Enter your email!'),
    phone_number: Yup.string().required('Enter your phone number!'),
});

const StepOne = ({
    setValuesToFormData,
    nextStep,
    checkIfUserEmailOrPhoneNumberExists,
    authentication,
}) => {
    const {
        isUserEmailOrPhoneNumberExistsRequest,
        isUserEmailOrPhoneNumberExistsSuccess,
        isUserEmailOrPhoneNumberExistsFailure,
    } = authentication;

    const { error, data } = isUserEmailOrPhoneNumberExistsFailure;

    return (
        <Container>
            {isUserEmailOrPhoneNumberExistsRequest && <LoadingScreen />}
            {isUserEmailOrPhoneNumberExistsSuccess && nextStep('stepTwo', 1)}

            <BoxWrapper mt="50">
                <Grid container justify="center">
                    <Grid item xs={12} md={4}>
                        <Formik
                            initialValues={{
                                name: '',
                                email: '',
                                phone_number: '',
                            }}
                            enableReinitialize
                            validationSchema={stepOneValidationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                checkIfUserEmailOrPhoneNumberExists(values.email, values.phone_number);
                                setValuesToFormData(values);
                                setSubmitting(false);
                            }}
                        >
                            {({
                                values,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                isValid,
                            }) => (
                                <Form onSubmit={handleSubmit}>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <FormControlInput
                                            instruction="Sure, we don't actually *need* to know this, but it helps us make things friendly."
                                            label="Enter first name"
                                            name="name"
                                            type="text"
                                            color="secondary"
                                            value={values.name}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                        />
                                    </BoxWrapper>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <FormControlInput
                                            instruction="This is really important, so we can send you the results of our questions. We value your privacy and will never sell you things or share with marketing companies. You can opt out at any time."
                                            label="Enter email"
                                            name="email"
                                            type="email"
                                            color="secondary"
                                            value={values.email}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                        />
                                        {(error && data.hasOwnProperty('email')) && (
                                            <CustomTypography
                                                customcolor={colors.secondary['500']}
                                                fontSize="1.2"
                                            >
                                                {data.email[0]}
                                            </CustomTypography>
                                        )}
                                    </BoxWrapper>
                                    <BoxWrapper mb="50" justifyContent="flex-start">
                                        <WrapperFormControl
                                            name="phone_number"
                                            instruction="The best way for us to send you your daily Mobilise Moment is via SMS. You can opt out at any time."
                                        >
                                            <PhoneInput
                                                placeholder=""
                                                inputProps={{
                                                    name: 'phone_number',
                                                }}
                                                specialLabel="Phone number"
                                                value={values.phone_number}
                                                preferredCountries={['gb', 'ca', 'us', 'au', 'nz']}
                                                country="gb"
                                                countryCodeEditable={false}
                                                masks={{
                                                    gb: '..... ......',
                                                }}
                                                onChange={(value, country, e, formattedValue) =>
                                                    handleChange(e, formattedValue)
                                                }
                                            />
                                            {(error && data.hasOwnProperty('phone_number')) && (
                                                <CustomTypography
                                                    customcolor={colors.secondary['500']}
                                                    fontSize="1.2"
                                                >
                                                    {data.phone_number[0]}
                                                </CustomTypography>
                                            )}
                                        </WrapperFormControl>
                                    </BoxWrapper>

                                    <BoxWrapper>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            mt="20"
                                            width="50"
                                            type="submit"
                                            disabled={isDisabled(values, isValid)}
                                        >
                                            Continue
                                        </Button>
                                    </BoxWrapper>
                                </Form>
                            )}
                        </Formik>
                    </Grid>
                </Grid>
            </BoxWrapper>
        </Container>
    );
};

const mapStateToProps = ({ authentication }) => {
    return { authentication };
};

const mapDispatchToProps = (dispatch) => ({
    checkIfUserEmailOrPhoneNumberExists: (email, phoneNumber) =>
        dispatch(checkIfUserEmailOrPhoneNumberExistsAction(email, phoneNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StepOne);
